<app-page-header-job [isCurveGray]="true" header="{{language.jobheader}}" backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<section class="section--feature">
  <div class="container">
    <div class="row radio--menu">
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <app-big-radio [active]="Personal" icon="assets/images/icon/user-job.png" title="{{language.jobtitleicon1}}">
        </app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Education" icon="assets/images/icon/mortarboard-job.png"
          title="{{language.jobtitleicon2}}"></app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Family" icon="assets/images/icon/family-room-job.png"
          title="{{language.jobtitleicon3}}"></app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Experience" icon="assets/images/icon/suitcase-job.png"
          title="{{language.jobtitleicon4}}"></app-big-radio>
      </div>
    </div>
  </div>
</section>

<div ng-app="MyApp" ng-controller="MyController">

  <!-- ประวัติการทำงาน -->
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center card p-5 mt-5 mb-5">

        <header class="heading-contact mb-5">
          <h2 class="topic-title">{{language.jobapplydetail18}}</h2>
          <p class="ingnor-top">* {{language.jobeduwarning2}} -</p>
        </header>

        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobapplydetail19}}</div>
            </div>
          </div>
        </div>

        <!-- add cv -->
        <div class="row">

          <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
            <div class="title d-flex">{{language.jobexptest}}</div>
            <input type="file" class="pl-5" [(ngModel)]="file1" (change)="uploadFile($event)" #fileUpload hidden>

            <div class="form--item">
              <!-- <div class="title" formControlName="file1">แนบผลสอบวัดระดับภาษา </div> -->
              <div class="input">
                <div class="input--container">
                    <input lass="pl-5" type="text" [(ngModel)]="file1" accept="" placeholder=''
                      [ngClass]="{ 'is-invalid': Reqfile1 }" disabled />
                </div>
                <div *ngIf="Reqfile1" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-3 mb-4">
            <div *ngIf="Filenames != '' && Filenames != undefined">
              <div class="title file mt-1">{{language.jobeduwarning3}}</div>
              <app-button-job text="{{language.jobbtn2}}" (click)="Delete()">
                <button class="button--blue ml-auto mr-auto">
                  <span>
                    <a>{{language.jobbtn2}}</a>
                  </span>
                </button>
              </app-button-job>
            </div>
          </div>

          <div class="col-lg-2 col-md-2 col-sm-3 mb-4">
            <div class="title file mt-1">.pdf .jpg .png .docx </div>
            <app-button-job text="{{language.jobbtn3}}" (click)="fileUpload.click()">
              <button class="button--blue ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn3}}</a>
                </span>
              </button>
            </app-button-job>
          </div>
          <!-- <div class="col-lg-4 col-md-4 col-sm-3 mb-4">
            <div class="title file mt-1">{{language.jobeduwarning1}}</div>
            <app-button-job text="{{language.jobbtn4}}" (click)="UploadFile()">
              <button class="button--blue ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn4}}</a>
                </span>
              </button>
            </app-button-job>
          </div> -->
        </div>

        <form [formGroup]="formDataresume">
          <div formArrayName="resumeInfo"
            *ngFor="let Dataresume of formDataresume.get('resumeInfo')['controls']; let i = index">
            <ng-container [formGroupName]="i">

              <div class="row">

                <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                  <div class="title-group">{{language.jobnumber}} {{i+1}}</div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                  <app-button-delete-job text="{{language.jobbtn2}}" (click)="removeResume(i)">
                    <button class="button--primary">
                      <span>
                        <a routerLink="">{{language.jobbtn2}}</a>
                      </span>
                    </button>
                  </app-button-delete-job>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail20}}</div>
                    <div class="input">
                      <div class="input--container" *ngIf="flag == 'th'; else elseDateFrom">
                        <my-date-picker-th formControlName="lastjob_from" value="ToMonthYear" id="ToMonthYear">
                        </my-date-picker-th>
                      </div>
                      <ng-template #elseDateFrom>
                        <my-date-picker formControlName="lastjob_from" value="ToMonthYear" id="ToMonthYear">
                        </my-date-picker>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail21}}</div>
                    <div class="input">
                      <div class="input--container" *ngIf="flag == 'th'; else elseDateTo">
                        <my-date-picker-th formControlName="lastjob_to" value="ToMonthYear" id="ToMonthYear">
                        </my-date-picker-th>
                      </div>
                      <ng-template #elseDateTo>
                        <my-date-picker formControlName="lastjob_to" value="ToMonthYear" id="ToMonthYear">
                        </my-date-picker>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail22}} </div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="lastjob_company" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqlastjob_company }">
                      </div>
                      <div *ngIf="checkNull(Dataresume.controls.lastjob_company.value) && fileToUpload == null" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail23}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="lastjob_position" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqlastjob_position }">
                      </div>
                      <div *ngIf="checkNull(Dataresume.controls.lastjob_position.value) && fileToUpload == null" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
<!--  -->
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail60}} </div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="lastjob_start_salary" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqlastjob_start_salary }" [maxLength]="13" numbersOnly>
                          <!-- <input (input)="lastjob_start_salary=$event.target.value" type="text" name="lastjob_start_salary"
                                        class="form-control" [(ngModel)]="lastjob_start_salary" [maxLength]="13"
                                        [ngClass]="{ 'is-invalid': Reqlastjob_start_salary }" numbersOnly />   -->
                      </div>
                      <div *ngIf="Reqlastjob_start_salary" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobapplydetail61}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="lastjob_end_salary" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqlastjob_end_salary }" [maxLength]="13" numbersOnly>
                      </div>
                      <div *ngIf="Reqlastjob_end_salary" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="title d-flex">{{language.jobexpdetail1}} 
                    <p class="max-character" [ngStyle]="{'color': lastjob_descript.value.length == 100 ? 'red' : 'black'}">
                      ({{lastjob_descript.value.length}}/ 100 {{language.jobexpdetail2}})</p>
                  </div>
                  <div class="input--container">
                    <textarea #lastjob_descript type="text" formControlName="lastjob_descript" class="form-control"
                      [ngClass]="{ 'is-invalid': Reqlastjob_descript }" maxlength="100"></textarea>
                    <!-- <div *ngIf="detailReq" class="error-message">กรุณาใส่รายละเอียด</div> -->
                  </div>
                  <div *ngIf="Reqlastjob_descript" class="error-message">
                    {{language.joberror1}}
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div class="title d-flex">{{language.jobapplydetail40}} 
                    <p class="max-character" [ngStyle]="{'color': lastjob_leaving.value.length == 100 ? 'red' : 'black'}">
                      ({{lastjob_leaving.value.length}}/ 100 {{language.jobexpdetail2}})</p>
                  </div>
                  <div class="input--container">
                    <textarea #lastjob_leaving type="text" formControlName="lastjob_leaving" class="form-control"
                      [ngClass]="{ 'is-invalid': Reqlastjob_leaving }" maxlength="100"></textarea>
                    <!-- <div *ngIf="detailReq" class="error-message">กรุณาใส่รายละเอียด</div> -->
                  </div>
                  <div *ngIf="Reqlastjob_leaving" class="error-message">
                    {{language.joberror1}}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </form>
        <div class="row" *ngIf="clickCount != 5">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
            <app-button-job text="{{language.jobbtn1}}" (click)="addResume()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn1}}</a>
                </span>
              </button>
            </app-button-job>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobapplydetail38}}</div>
              <div class="input">
                <div class="input--container" *ngIf="flag == 'th'; else elseDateFrom">
                  <my-date-picker-th [options]="myDatePickerOptions" [(ngModel)]="lastjob_hiring_date" value="lastjob_hiring_date" id="lastjob_hiring_date">
                  </my-date-picker-th>
                </div>
                <ng-template #elseDateFrom>
                  <my-date-picker [options]="myDatePickerOptionsEN" [(ngModel)]="lastjob_hiring_date"  value="lastjob_hiring_date" id="lastjob_hiring_date">
                  </my-date-picker>
                </ng-template>
                <div *ngIf="Reqlastjob_hiring_date" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
            <div class="title d-flex">{{language.jobapplydetail39}} 
              <!-- <p class="max-character" [ngStyle]="{'color': lastjob_hobby.length == 100 ? 'red' : 'black'}">
                ({{lastjob_hobby.length}}/ 100 {{language.jobexpdetail2}})</p> -->
            </div>
            <div class="input--container">
              <textarea  type="text" (input)="lastjob_hobby=$event.target.value" class="form-control"
                [ngClass]="{ 'is-invalid': Reqlastjob_hobby }" maxlength="100"></textarea>
            </div>
            <div *ngIf="Reqlastjob_hobby" class="error-message">
              {{language.joberror1}}
            </div>
          </div>
        </div>        

        <!-- ถัดไป -->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
            <app-button text="{{language.jobbtn6}}" (click)="goFamily()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn6}}</a>
                </span>
              </button>
            </app-button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
            <app-button text="{{language.jobbtn5}}" (click)="goAnother()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn5}}</a>
                </span>
              </button>
            </app-button>
          </div>
        </div>
        <!-- ถัดไป -->

      </div>
    </div>
  </div>
  <!-- ประวัติการทำงาน -->

</div>